import { Injectable } from '@angular/core';
import { HttpInterceptorService } from '@ispm/core/services/http-interceptor.service';
import { Observable } from 'rxjs';

@Injectable()
export class RetriggerUserActivationService {
  private readonly baseUrl = '/auth';

  constructor(private _http: HttpInterceptorService) {

  }

  private retriggerRequest(emailAddress) {
    const body = {
      'loginId': emailAddress
    };
    const req = this._http.post(this.baseUrl + '/retriggerUserActivation', body, true, )
      .map((res) => {
        return res.body;
      }).catch(err => {
        return Observable.throwError(err);
      }).publish();
    req.connect();
    return req;
  }
}
